'use strict';

var React = require('react');

var SvgAnalyticsBarStackedMinor = function SvgAnalyticsBarStackedMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 5.75a2.25 2.25 0 0 0-2.25 2.25v4a2.25 2.25 0 0 0 2.25 2.25h9.5a2.25 2.25 0 0 0 2.25-2.25v-4a2.25 2.25 0 0 0-2.25-2.25h-9.5Zm-.75 2.25a.75.75 0 0 1 .75-.75h4.75v5.5h-4.75a.75.75 0 0 1-.75-.75v-4Zm8.5 4.75h1.75a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-.75-.75h-1.75v5.5Z"
  }));
};
SvgAnalyticsBarStackedMinor.displayName = "AnalyticsBarStackedMinor";

exports.SvgAnalyticsBarStackedMinor = SvgAnalyticsBarStackedMinor;
